import _ from 'lodash';
import environment from '../../environment';
import Leaflet from '../Leaflet';
import ColorBrewer from '../../core/tools/colorbrewer';

class ClientSalesAfterSalesLayer {
    constructor (currentMap) {
        return new Leaflet.D3Layer({
            map: currentMap,
            remote: {
                method: 'POST',
                url: `${environment.get('API_HOST')}/aftersales/stores/sales`,
                params: {
                    type: 1
                }
            },
            showAll: true,
            uniqueField: 'StoreId',
            type: 'heat',
            symbology: {
                type: 'single',
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_BLUE),
                    property: 'Value'
                }
            },
        });
    }
}

export default ClientSalesAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/ClientSalesAfterSalesLayer.js